import React from 'react';
import { FormGroup, Input, Label, Nav, NavItem, NavLink, Form } from 'reactstrap';
import { MONTHS } from 'constants/general';
import { Field, reduxForm } from 'redux-form'
import VISA from 'assets/images/visa.png';
import MASTER from 'assets/images/master.png';
import MAESTRO from 'assets/images/maestro.png';
import AMEX from 'assets/images/amex.svg';
import AMEXPNG from 'assets/images/amex.png';
import RUPAY from 'assets/images/rupay.png';
import UNIONPAY from 'assets/images/unionpay.png';
import PCICSS from 'assets/images/footer.svg';
import FMASTER from 'assets/images/footer-1.svg';
import FVISA from 'assets/images/footer-2.svg';
import FRUPAY from 'assets/images/footer-3.svg';
import FNORTON from 'assets/images/footer-4.svg';
import JCB from 'assets/images/jcb.svg'
//FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
import IMSLOGO from 'assets/images/imsfooter.svg';
import NONIMSLOGO from 'assets/images/nonImsfooter.svg';
import { redirectToCancelUrl } from 'actions/payment';
import { ccFormat, removeWhiteSpaces, numberAndUpdateCvv, cardMaxLength, cvvMaxLength, onDropAlphawithsinglespace, numberOnly, avoidPasting , normalizePhone, alphawithsinglespace, alphaNumeric, onlyNumberAndDot, alphaNumericSpecial} from 'lib/fp-utility';
import {
    combineValidators,
    isRequired,
} from 'revalidate'
export const PhoneNumber = (props) => (
  
        <Field
        name="phone"
        component="input"
        onDrop={onDropAlphawithsinglespace}
        name="phone[phonenumber]"
        type="text"
        placeholder="Phone Number"
        normalize={normalizePhone}
        disabled={props.disabled}
        className={props.className}
    />

)
export const CardNumber = (props) => (
    <Field 
        placeholder="Card Number"
        onDrop={onDropAlphawithsinglespace}
        cardType={props.cardType}
        id="number"
        type="tel"
        name="card[cardNumber]"
        component={NumberInput}
        onFocus={(e)=> props.updateFormatedCardNo(removeWhiteSpaces(e.target.value))}
        updateFormatedCardNo={props.updateFormatedCardNo}
        normalize={props.normalize}
        onChange={props.onChange}
        onBlur = {props.onBlur}
        normalize={ (value) => numberOnly(value) }
        disabled={props.disabled}
        validate={[props.validateCardType]}
    />
)

export const CardHolderName = (props) => (
    <Field
        placeholder="Name of Card Holder"
        onDrop={onDropAlphawithsinglespace}
        type="text"
        id="name"
        maxLength={100}
        info={props.info}
        name="card[nameOnCard]"
        component={TextInput}
        onPaste={avoidPasting}
        normalize={props.normalize}
    />
)

export const ExpiryGroup = ({from, cardType, onMouseEnter, onMouseLeave, updateCvv, getCvv}) => (
    <FormGroup className="date-panel">
        <Label for="exampleSelect">Expiry Date</Label>
        <Field name="card[expMonth]" component={FPMonths} />
        <Field name="card[expYear]" from={from} component={FPYears} />
        <Field name="myCvv" id="cvv" onDrop={onDropAlphawithsinglespace} component={CVVField} placeholder="CVV" autoComplete="new-password" normalize={(value) => numberAndUpdateCvv(value, updateCvv, getCvv)} cardType={cardType}/>
        <span 
            id="cvvInfo"
            className="icon-info" 
            onMouseEnter={onMouseEnter} 
            onMouseLeave={onMouseLeave}
        >
        </span>
        <span style={{"display": "block", "padding":"0"}} id="invalidExpMM" className="error"></span>
        <span style={{"display": "block", "padding":"0"}} id="invalidExpYY" className="error"></span>
        <span style={{"display": "block", "padding":"0"}} id="invalidExpDate" className="error"></span>
        <span style={{"display": "block", "padding":"0"}} id="invalidCvv" className="error"></span>
    </FormGroup>
)

export const SaveCardAutoInfo = ({note, t, onChange,checked}) => (
    <FormGroup className="mb-3 auto-height">
        <Label className="custom-check">Setup automatic payments
            <Field checked={checked|| false} name="standingInstruction" onChange={onChange} component='input' type='checkbox' />
            <span className="checkmark"></span>
        </Label>
    </FormGroup>
)

export const SaveCardInfo = ({note, t}) => (
    <FormGroup className="m-0">
        <Label className="custom-check">{t('save_info')}
        <Field name="card[vaultCard]" component='input' type='checkbox' />
        {/* <Input type="checkbox" /> */}
        <span className="checkmark"></span>
        </Label>
        <p className="text-14"><strong>{t('Note')}</strong> : {t('savedcard_note1')}</p>
    </FormGroup>
)

export const StandingInstruction = (props) => (
    <FormGroup className="m-0">
        <Label className="custom-check">Save Card For Auto Debit
        <Field name="standingInstruction" onChange={props.onChange} component='input' type='checkbox' />
        {/* <Input type="checkbox" /> */}
        <span className="checkmark"></span>
        </Label>
    </FormGroup>
)

export const TextInput = ({setDisabled, defaultValue, input, info, maxLength, parentClassName, onKeyPress, id, autoComplete, placeholder, type, meta: { touched, error, warning } }) => {
        if(!setDisabled){
            return ( 
                <FormGroup className={parentClassName}>
                <Input {...input} 
                className={`${touched && error ? 'error' : ''} `} 
                autoComplete={autoComplete} 
                maxLength={maxLength} 
                id={id} 
                value={defaultValue}
                onPaste={avoidPasting}
                onKeyPress={onKeyPress}
                disabled={setDisabled} 
                placeholder={placeholder} 
                type={type} />
                {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
                { info && 
                    <div className="text-14 cardHolderInfo">
                        <span className="icon-info"></span>
                        <p>For Maestro cards, if Expiry Date and CVV no is not available please ignore and proceed</p>
                    </div>
                }
            </FormGroup>
            )
        }else if(setDisabled){
            return (<div style={{margin:"10px"}}>{placeholder}: {defaultValue}</div>)
        }
}
   
export const AmountInput = ({ input,setDisabled,defaultValue, onKeyUp,cardType, id, autoComplete, placeholder, type, currencyCode, meta: { touched, error, warning }, updateFormatedCardNo, disabled }) =>
{
    if(!setDisabled){
        return (
            <FormGroup className="inputShowCard">
            <Input {...input} 
                maxLength={16} 
                onPaste={avoidPasting} 
                onKeyUp={onKeyUp} 
                className={`${touched && error ? 'error' : ''} `} 
                autoComplete={autoComplete} 
                id={id} 
                onBlur={ (e) => {
                        input.onBlur(e)
                       //  return updateFormatedCardNo(ccFormat(e.target.value)); 
                    }
                }
                placeholder={placeholder} 
                type={type}
                disabled={disabled}
            />
           
            {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
        </FormGroup>
        )
    }else if(setDisabled){
        return (<div style={{margin:"10px"}}>{placeholder} {currencyCode ? currencyCode + ' ' : ''}{defaultValue}</div>)
    }
}



   


export const CardImage = ({cardType}) => (
    <>  
        { cardType==='MASTER' && <img src={MASTER} alt="" title="" />}
        { cardType==='MASTERCARD' && <img src={MASTER} alt="" title="" />}
        { cardType==='MAESTRO' && <img src={MAESTRO} alt="" title="" />}
        { cardType==='AMEX' && <img src={AMEXPNG} alt="" title="" />}
        { cardType==='RUPAY' && <img src={RUPAY} alt="" title="" />}
        { cardType==='VISA' && <img src={VISA} alt="" title="" />}
        { cardType==='UNIONPAY' && <img src={UNIONPAY} alt="" title="" />}
    </>
)
// commented below -FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
// export const PaymentSupportedBrandsImg = ({brandName}) => (
//     <>  
//         { brandName==='pciCss' && <img src={PCICSS} alt="" title="" />}
//         { brandName==='master' && <img src={FMASTER} alt="" title="" />}
//         { brandName==='visa' && <img src={FVISA} alt="" title="" />}
//         { brandName==='rupay' && <img src={FRUPAY} alt="" title="" />}
//         { brandName==='amex' && <img src={AMEX} alt="" title="" className="pl-3" />}
//         { brandName==='norton' && <img src={FNORTON} alt="" title="" />}
//         { brandName==='unionpay' && <img src={UNIONPAY} alt="" className="pl-2"  height="30" width="70" title="" />}
//         { brandName==='jcb' && <img src={JCB} alt=""  height="30" width="70" title="" />}
//     </>
// )

//FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
export const LogosBasedOnRegion = ({region}) => (
    <>  
        { region==='imsLogo' && <img src={IMSLOGO} alt="" title="" />}
        { region==='nonImsLogo' && <img src={NONIMSLOGO} alt="" title="" />}
    </>
)


export const NumberInput = ({ input, onKeyUp,cardType, id, autoComplete, placeholder, type, meta: { touched, error, warning }, updateFormatedCardNo, disabled }) => (
    <FormGroup className="inputShowCard">
        <Input {...input} 
            maxLength={cardMaxLength(cardType)} 
            onPaste={avoidPasting} 
            onKeyUp={onKeyUp} 
            className={`${touched && error ? 'error' : ''} `} 
            autoComplete={autoComplete} 
            id={id} 
            onBlur={ (e) => {
                    input.onBlur(e)
                    return updateFormatedCardNo(ccFormat(e.target.value)); 
                }
            }
            placeholder={placeholder} 
            type={type}
            disabled={disabled}
        />
        <CardImage cardType={cardType} />
        {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
    </FormGroup>
)

// export const DateInput = ({ input, type, name, hasError, errorMessage, className, value, placeholder, id, autoComplete, onKeyPress, onClick, onBlur }) => (
export class DateInput extends React.Component{
    render(){
        const { input, type, name, hasError, errorMessage, className, value, placeholder, id, autoComplete, onKeyPress, onClick, onBlur, from, disableDate } = this.props
        return (
                <>
                    <Input {...input} 
                        type={type}
                        name={name}
                        defaultValue={value}
                        placeholder={placeholder}
                        id={id}
                        readOnly={true}
                        disabled={disableDate}
                        autoComplete={autoComplete}
                        onDrop={onDropAlphawithsinglespace}
                        onPaste={avoidPasting} 
                        onKeyPress={onKeyPress} 
                        onClick={onClick}  
                        onBlur={onBlur} 
                        className={className}
                    />
                    {hasError && <span id={`${from}Error`} className='error'>{errorMessage}</span>}
                </>
            )
        }
}

export const FPMonths = ({ input, meta: { touched, error } }) => {
    let currentMonth = new Date().getMonth() + 1;
    return (
        <div className="custom-dd">
            <Input {...input} type="select" id="month">
                <option value=''>MM</option>
                {MONTHS.map((month, i) => <option key={i} value={month.value} defaultValue={`${month.value === currentMonth ? 'selected' : ''}`} >{month.value}</option>)}
            </Input>
            { touched && showExpDayError('MM', error) }
        </div>
    );
}

function resetInvalidExpDate(error=''){
    if(document.getElementById('invalidExpDate'))
        document.getElementById('invalidExpDate').innerHTML=error
}

function showExpDayError(type, error){
    if(error==="invalidExpiry"){ // Display Error if the selected Day is Past
        if(document.getElementById('invalidExpMM')){
            document.getElementById('invalidExpMM').innerHTML=''
            document.getElementById('invalidExpYY').innerHTML=''
            document.getElementById('invalidExpDate').innerHTML='Please enter valid expiry date'
        }
    }else if(type==='MM'){ // MM Should not blank
        resetInvalidExpDate()
        if(error)
            resetInvalidExpDate(error)
        else
        resetInvalidExpDate()
    }else if(type==='YY'){ // YY Should not blank
        resetInvalidExpDate()
        if(error)
            resetInvalidExpDate(error)
        else
            resetInvalidExpDate()
    }
    return ''
}

export const FPYears = ({ input, from, meta: { touched, error } }) => {
    let min = new Date().getFullYear(),
        max = min + 12,
        i = min,
        years = [];
    for (; i <= max; i++) {
        let formattedYear = i.toString().substr((from==='IDC' ? 0 : -2));
        years.push({ optionValue: formattedYear, displayValue: i });
    }
    return (
        <div className="custom-dd">
            <Input {...input} type="select" id="year">
                <option value=''>YYYY</option>
                {
                    years.map((year, i) => 
                    <option key={i} value={year.optionValue}>{year.displayValue}</option>)
                }
            </Input>
            { touched && showExpDayError('YY', error) }
        </div>
    );
}

export const CVVField = ({ input, className, id, normalize, autoComplete, placeholder, type, cardType, meta: { touched, error, warning } }) => (
    <Input onPaste={avoidPasting} minLength={3} maxLength={cvvMaxLength(cardType)}  {...input} className={className} autoComplete={autoComplete} id={id} normalize={normalize} placeholder={placeholder} type='text' />
)

export const SelectInput = ({ setDisabled , selectValue, input, className, blank, options, meta: { touched, error, warning } }) => {
    return (
        <>
         
         <select disabled={setDisabled} {...input} value={selectValue || ""} className={className}>
             { blank && <option value=''>{blank}</option> }
             {
                 options.map((val, i) => <option key={val.value} issuername={val.displayName} value={val.value}>{val.displayName}</option>)
             }
         </select>
         {
             touched && ((error && <span className='error'>{error}</span>) || (warning && <span>{warning}</span>))
         }
        </>
            )
 
}

export const CheckboxInput = ({ input, className, meta: { touched, error, warning } }) => (
    <>
        <input {...input} className={className} type='checkbox' />
        {
            touched && ((error && <span className='error'>{error}</span>) || (warning && <span>{warning}</span>))
        }
    </>
)

export const FDButton = ({ disabled, value }) => (
    <button type="submit" disabled={disabled} >{value}</button>
)

export const ACSForm = ({threeDSecureRequest, name}) => {
    if(!threeDSecureRequest.is3ds2Integration) {
    return( 
        <form name={name} action={threeDSecureRequest.acsURL} method="POST">
            <input type='hidden' name='PaReq' defaultValue={threeDSecureRequest.paReq} />
            <input type='hidden' name='TermUrl' defaultValue={threeDSecureRequest.termURL} />
            <input type='hidden' name='MD' defaultValue={threeDSecureRequest.md} />
        </form>
        )
    } else {
        return (
            <form id={threeDSecureRequest.tdsFormId} name={threeDSecureRequest.tdsFormName} action={threeDSecureRequest.tdsActionUrl} method="POST">
                <input type='hidden' name="creq" id="creq" defaultValue={threeDSecureRequest.creq} />
                <input type='hidden' name="termUrl" id="termUrl" defaultValue={threeDSecureRequest.termURL} />
            </form>                
        )
    }
}

// export const RupayForm = ({rupayCardRequestBean}) => (
export class RupayForm extends React.Component {
    componentDidMount(){
        if(document[this.props.name]){
            document[this.props.name].submit();
        }
    }
    render() {
        const { rupayCardRequestBean } = this.props
        return(
            <form name={this.props.name} action={rupayCardRequestBean.formUrl} method="POST">
                <input type='hidden' name='txntype' defaultValue={rupayCardRequestBean.txntype} />
                <input type='hidden' name='timezone' defaultValue={rupayCardRequestBean.timezone} />
                <input type='hidden' name='txndatetime' defaultValue={rupayCardRequestBean.txndatetime} />
                <input type='hidden' name='hash' defaultValue={rupayCardRequestBean.hash} />
                <input type='hidden' name='hash_algorithm' defaultValue={rupayCardRequestBean.hash_algorithm} />
                <input type='hidden' name='storename' defaultValue={rupayCardRequestBean.storename} />
                <input type='hidden' name='mode' defaultValue={rupayCardRequestBean.mode} />
                <input type='hidden' name='chargetotal' defaultValue={rupayCardRequestBean.chargetotal} />
                <input type='hidden' name='currency' defaultValue={rupayCardRequestBean.currency} />
                <input type='hidden' name='oid' defaultValue={rupayCardRequestBean.oid} />
                <input type='hidden' name='responseFailURL' defaultValue={rupayCardRequestBean.responseFailURL} />
                <input type='hidden' name='responseSuccessURL' defaultValue={rupayCardRequestBean.responseSuccessURL} />
                <input type='hidden' name='mobileMode' defaultValue={rupayCardRequestBean.mobileMode} />
                <input type='hidden' name='bname' defaultValue={rupayCardRequestBean.bname} />
                <input type='hidden' name='cardnumber' defaultValue={rupayCardRequestBean.cardnumber} />
                <input type='hidden' name='expmonth' defaultValue={rupayCardRequestBean.expmonth} />
                <input type='hidden' name='expyear' defaultValue={rupayCardRequestBean.expyear} />
                <input type='hidden' name='cvm' defaultValue={rupayCardRequestBean.cvm} />
                <input type='hidden' name='sharedsecret' defaultValue={rupayCardRequestBean.sharedsecret} />
                <input type='hidden' name='full_bypass' defaultValue={rupayCardRequestBean.full_bypass} />
                <input type='hidden' name='assignToken' defaultValue={rupayCardRequestBean.assignToken} />
                <input type='hidden' name='hosteddataid' defaultValue={rupayCardRequestBean.hosteddataid} />
            </form>
        )
    }
}

export class RazorPayResponseForm extends React.Component {
    componentDidMount(){
        if(document[this.props.name]){
         document[this.props.name].submit();
        }
    }
    render() {
        const { razorPayRespData } = this.props
        return(
            <form name={this.props.name} action={razorPayRespData.formUrl} method="POST">
                { razorPayRespData.paymentId && 
                    <input type='hidden' name='paymentId' defaultValue={razorPayRespData.paymentId} /> 
                }
                <input type='hidden' name='orderId' defaultValue={razorPayRespData.orderId} />
                <input type='hidden' name='sessionTokenId' defaultValue={razorPayRespData.sessionTokenId} />
                { razorPayRespData.responseError && 
                    <input type='hidden' name='Error' defaultValue={razorPayRespData.responseError} /> 
                }
            </form>
        )
    }
}

export class PayLaterResponseForm extends React.Component {
    componentDidMount(){
        if(document[this.props.name]){
         document[this.props.name].submit();
        }
    }
    render() {
        const { payLaterRespData,nbRespURL,sessionID } = this.props;

        return(
            <form name={this.props.name} action={nbRespURL} method="POST">
                { payLaterRespData.payLaterPaymentID && 
                    <input type='hidden' name='paymentId' defaultValue={payLaterRespData.payLaterPaymentID} /> 
                }
                {/* <input type='hidden' name='orderId' defaultValue={payLaterRespData.orderId} /> */}
                <input type='hidden' name='sessionTokenId' defaultValue={sessionID} />
                { payLaterRespData.transactionStatus == "FAILED" && 
                    <input type='hidden' name='Error' defaultValue={payLaterRespData.errorMessage} /> 
                }
            </form>
        )
    }
}


export class BharathQRResponseForm extends React.Component {
    componentDidMount(){
       // console.log("PROPS NAME",this.props.name)
        if(document[this.props.name]){
         document[this.props.name].submit();
        }
    }
    render() {
        const { transactionStatus,nbRespURL,sessionID,userCancelled } = this.props;
        // console.log("USER CANECLLED",userCancelled)
        return(
         <>
         {transactionStatus === "SUCCESS" && 
         <form class="success-fomr" name={this.props.name} action={decodeURIComponent(nbRespURL)} method="POST"></form>
        }
         {( transactionStatus !== "SUCCESS") && 
            <form  name={this.props.name} action={nbRespURL} method="POST">
            {/* <input type='hidden' name='orderId' defaultValue={payLaterRespData.orderId} /> */}
            {userCancelled && 
            <input className="d-none" type='hidden 'name='txnStatusDescription' defaultValue="Cancel By user"/>
            }
            <input type='hidden' name='sessionTokenId' defaultValue={sessionID} />
                <input type='hidden' name='Error' defaultValue={transactionStatus} /> 
            </form>
        }
         </>
        )
    }
}


export class UPIResponseForm extends React.Component {
    componentDidMount(){
        if(document[this.props.name]){
         document[this.props.name].submit();
        }
    }
    render() {
        const { transactionStatus,nbRespURL,sessionID } = this.props;
        return(
        <> 
        {transactionStatus === "SUCCESS" && 
         <form name={this.props.name} action={decodeURIComponent(nbRespURL)} method="POST"></form>
        }
        {(transactionStatus !== "SUCCESS") && 
            <form name={this.props.name} action={nbRespURL} method="POST">
            {/* <input type='hidden' name='orderId' defaultValue={payLaterRespData.orderId} /> */}
            <input type='hidden' name='sessionTokenId' defaultValue={sessionID} />
                <input type='hidden' name='Error' defaultValue={transactionStatus} /> 
            </form>
        }
        </>
         
        )
    }
}


export const DisplayPayBtnText = ({ cardMetaData, transactionDetails, selectedEMIOption, t, labelName }) => (
    <>
        <span>{t(labelName ? labelName : 'pay')}</span>                            
        {

            selectedEMIOption && selectedEMIOption.emiCurrency && selectedEMIOption.emitotalamt ?
                <span className="text-right">
                    {t(selectedEMIOption.emiCurrency)} {transactionDetails.amount}
                </span>
            : (
                cardMetaData && cardMetaData.convFee && cardMetaData.convFee.totalAmount!=="0" ? (
                    <span className="text-right">
                        {t(cardMetaData.convFee.currencyCode)} {cardMetaData.convFee.totalAmount}
                    </span>
                ) : <span className="text-right">
                        {t(transactionDetails.currencyCode)} {transactionDetails.amount}
                    </span>
             )
        }
    </>
)

export const DisplayConvFee = ({ cardMetaData, t }) => (
    <>
        {
            cardMetaData && cardMetaData.convFee && cardMetaData.convFee.totalAmount!=="0" && (
                <div className="price-panel">
                    <Nav>
                        <NavItem className="text-16">Total 
                            <span className="float-right">
                                <label>{t(cardMetaData.convFee.currencyCode)}</label> {cardMetaData.convFee.baseAmount}
                            </span>
                        </NavItem>
                        {
                            cardMetaData.convFee.fees.map((fee, i) => {
                                return <NavItem key={i} className="text-16">{fee.title} <span className="float-right"><label>{t(cardMetaData.convFee.currencyCode)}</label>{fee.amount}</span></NavItem>
                            })
                        }
                    </Nav>
                </div>    ) 
        }

    </>
)

export const DisplayConvFeeDiscription = ({ cardMetaData }) => (
    <>
        {
            cardMetaData && cardMetaData.convFee && cardMetaData.convFee.totalAmount!=="0" &&  
                (
                    <p className="text-14">*Convenience Fee is charged on - This information is specific to the merchant</p>
                )
        }

    </>
)

export const RenderForm = (props) => {
    const { iDebitUrl, formName, is3DSecure, isRupayCard, threeDSecureRequest, rupayCardRequestBean, nbRespURL, bharatTxnStatus, upiTxnStatus, non3DSecure, non3DSecureUrl, razorPayRespData , payLaterRespData,sessionID} = props;
    return (
        <>
            { 
                iDebitUrl && (<form name='IDEBITFORM' action={iDebitUrl} method="POST"></form>)
            }
            { 
                is3DSecure && <ACSForm name='ACSFORM' threeDSecureRequest={threeDSecureRequest} />
            }
            {
                isRupayCard && <RupayForm name='IPGFORM' rupayCardRequestBean={rupayCardRequestBean} />
            }
            {
                nbRespURL && (<form name={`${formName}_TPSLForm`} action={nbRespURL} method="POST"></form>)
            }
            {
                bharatTxnStatus && (bharatTxnStatus.transactionStatus==='AWAITED' || bharatTxnStatus.transactionStatus==='FAILED' || bharatTxnStatus.transactionStatus==='SUCCESS') && (
                
                // <form name={`${formName}_SCANForm`} action={decodeURIComponent(bharatTxnStatus.merchantRedirectUrl)} method="POST"></form>
                <BharathQRResponseForm name={`${formName}_SCANForm`} 
                 sessionID={sessionID} nbRespURL= {nbRespURL} transactionStatus={bharatTxnStatus.transactionStatus}
                  userCancelled = {bharatTxnStatus.userCancelled} />
                )
            }
            {
                upiTxnStatus && (upiTxnStatus.transactionStatus==='AWAITED' || upiTxnStatus.transactionStatus==='FAILED' || upiTxnStatus.transactionStatus==='SUCCESS') && (
                
                // <form name={`${formName}_UPIForm`} action={decodeURIComponent(upiTxnStatus.merchantRedirectUrl)} method="POST"></form>
                <UPIResponseForm name={`${formName}_SCANForm`} 
                 sessionID={sessionID} nbRespURL= {nbRespURL} transactionStatus={upiTxnStatus.transactionStatus} />

                )
            }
            {
                non3DSecure && (<form name='NON3DSECUREFORM' action={non3DSecureUrl} method="POST"></form>)
            }
            {
                razorPayRespData && <RazorPayResponseForm name='RAZORPAYFORM' razorPayRespData={razorPayRespData} />
            }
            {
                payLaterRespData && <PayLaterResponseForm name='PAYLATERFORM' sessionID={sessionID} nbRespURL= {nbRespURL} payLaterRespData={payLaterRespData} />
            }
        </>
    )
}

export const filterSCByBankName = (savedCards, bankName) => {
    return ((savedCards && bankName) ? savedCards.filter((sc)=> sc.issuerName === bankName ) : savedCards)
}

export const GoBack = (props) => {
    return (
        <p>
            <NavLink title={props.t('go_back_to_2')} onClick={redirectToCancelUrl}>
                {props.t('cancel_transaction')}
            </NavLink>
        </p>
    )
}

export class RedirectToURL extends React.Component {
    componentDidMount(){
        if(document[this.props.name]){
            document[this.props.name].submit();
        }
    }
    render() {
        return <form name={this.props.name} action={this.props.url} method="POST"></form>
    }
}

export class Timer extends React.Component {
    state = { secondsRemaining: this.props.secondsRemaining }
    timer = this.timer.bind(this);
    componentDidMount() {
        this.setState({ secondsRemaining: this.props.secondsRemaining });
        this.timerInterval = setInterval(this.timer, 1000);
    }
    componentWillUnmount() {clearInterval(this.timerInterval);}
    getInitialState() {
        return { secondsRemaining: 0 };
    }
    timer() {
        this.setState({secondsRemaining: this.state.secondsRemaining - 1});
        if (this.state.secondsRemaining <= 0) { clearInterval(this.timerInterval);}
    }
    render() {
        return <h6>Seconds Remaining: {this.state.secondsRemaining}</h6>
    }
}

export const FPImages = (img_path) => {
    const imgPath = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/${img_path.src}`;
    const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
    const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
    if(imgPath === "null" || imgPath.length === 0 || imgPath === "about:blank"){
        return  <p>{img_path}</p>
    }
    else if (imgPath.match(SAFE_URL_PATTERN) || imgPath.match(DATA_URL_PATTERN))
    {
        return <div style={{ width: "100%",
            height: "100%",
            backgroundSize: "100% 100%", 
            backgroundImage: `url('${imgPath}')` }}></div>
        // return <img className="img-size" src={require(imgPath)} alt="" title="" />;
    }else{
        return  <p>{img_path}</p>
    }
 
   
}

export const CellPhoneNumber = (props) => (
    <Field
    component="input"
    onDrop={onDropAlphawithsinglespace}
    name={props.fieldName}
    type="tel"
    placeholder="Phone Number"
    normalize={ (value) => numberOnly(value) }
    disabled={props.disabled}
    className={props.className}
    maxLength={12}
/>

)
const validate = (values, ownProps) => {

    const dynamicValidations = ownProps.data.reduce((accu, curr) => {
        if(!accu[curr.param]){
            accu[curr.param] = isRequired({ message: 'Please enter ' + curr.literal })
        }
        return accu
    }, {})
    return combineValidators({
        ...dynamicValidations
    })(values)
}

const renderField = ({ input, label, type, placeholder, maxLength, normalize, meta: { touched, error, warning } }) => (
    <div className="p-2">
      {/* <label>{label}</label>
      <div> */}
        <input {...input} placeholder={placeholder} maxLength={maxLength} normalize={normalize} type={type}/>
        {touched && ((error && <div className="error mt-1 p-0 text-left pl-lg-5 ml-lg-4">{error}</div>) || (warning && <span>{warning}</span>))}
      </div>
    // </div>
  )
 const renderStaticField = (field) => (
        <div className="form-group" key={field.param}>
        <Field name={field.param} placeholder={`Enter ${field.literal}`} label={field.literal}  className="form-control" type='text'
            maxLength={field.length}
            component={renderField}
            normalize={ (value) => {
                if(field.type === 'NUMBER'){
                    return onlyNumberAndDot(value) 
                } else if(field.type === 'ALPHANUMSPECIAL'){
                    return alphaNumericSpecial(value)
                } else if(field.type === 'ALPHANUMERIC'){
                    return alphaNumeric(value)
                } else {
                    return alphawithsinglespace(value)
                }

            } }
        />
    </div> 
 ) 
const StaticPaymentForm =  React.memo((props) => {
    const { handleSubmit, data, invalid } = props;
    return(
        <Form name='StaticPaymentForm' autoComplete='off'>
            { 
                data.map(field => {
                   return field.param === "statictxt" ? null 
                    : renderStaticField(field) 
                   })
            }
            { 
                data.map(field => {
                return field.param === "statictxt" ? <p>{field.literal}</p> 
                    : null
                })
            }
                <div className="form-group pt-3">
                    <button type="button" disabled={invalid} onClick={handleSubmit}  className="btn btn-secondary">Proceed</button>
                </div>
        </Form>
    )
})
export const StaticPaymentMethod = reduxForm({
    form: 'StaticPaymentForm',
    validate
})(StaticPaymentForm)